import React, { PureComponent, Fragment } from 'react';
import { createPortal } from 'react-dom';
import Icon from '~/core/scripts/components/Icon';

class Headline extends PureComponent {
  render() {
    return createPortal(
      <Fragment>
        <div className="topline">
          <span className="kicker">Quiz</span><Icon type="emoji"/>
        </div>
        <h1 className="title">{this.props.title}</h1>
        <h3 className="introtext">{this.props.introtext}</h3>
        <div className="attribution">Die Karten sind erstellt mit Hilfe von <a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> und <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a></div>
      </Fragment>,
      document.getElementById('headline')
    );
  }
}

export default Headline;
